<template>
    <form id="audit-data-form" @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="grid">
            <div class="col-12">
                <as-title class="title"
                    :title="$t('ficheBu.audit_data_form.' + (auditData.id ? 'edit_audit_data_title' : 'new_audit_data_title'))"
                    :size="3" />
            </div>
            <div v-if="auditDataAlreadyExisting" class="col-12 mb-3">
                <label class="p-error">{{ $t('rituals.ritual_form.already_exist') }}</label>
            </div>
            <div class="field col-12 pb-0 mb-3">
                <div class="p-float-label">
                    <Dropdown v-model="v$.selectedEntreprise.$model" :options="entreprisesOptions" optionLabel="label"
                        optionValue="value" :class="{ 'p-invalid': v$.selectedEntreprise.$invalid && submitted, }"
                        class="w-100" @update:modelValue="checkExistingAuditData()" />
                    <label>{{ $t("ficheBu.audit_data_form.audit_data_bu_field") }}</label>
                </div>
                <as-input-error :errors="v$.selectedEntreprise.$silentErrors" v-show="submitted" />
            </div>
            <div class=" field col-6 pb-0 mb-3">
                <div class="p-float-label">
                    <InputText type="number" v-model="v$.year.$model" class="w-100"
                        :class="{ 'p-invalid': v$.year.$invalid && submitted }"
                        @update:modelValue="checkExistingAuditData()" />
                    <label>{{ $t("ficheBu.audit_data_form.audit_data_year_field") }}</label>
                </div>
                <as-input-error :errors="v$.year.$silentErrors" v-show="submitted" />
            </div>
            <div class="field col-6 pb-0 mb-3">
                <div class="p-float-label">
                    <Dropdown v-model="v$.selectedValue.$model" :options="valueOptions" optionLabel="label"
                        optionValue="value" :class="{ 'p-invalid': v$.selectedValue.$invalid && submitted, }"
                        class="w-100" />
                    <label>{{ $t("ficheBu.audit_data_form.audit_data_value_field") }}</label>
                </div>
                <as-input-error :errors="v$.selectedValue.$silentErrors" v-show="submitted" />
            </div>
        </div>
        <div class="grid fixed-bottom">
            <div class="col flex justify-content-end">
                <Button :label="$t('form.cancel_button')" class="button-default"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-times'" @click="onClose"
                    :disabled="isSending" />
                <Button type="submit" :label="$t('form.submit_button')" class="button-primary ml-2"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                    :disabled="v$.$invalid || isSending || auditDataAlreadyExisting" />
            </div>
        </div>
    </form>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "@vuelidate/validators"
import { reactive, computed, } from "vue"

import AsTitle from "../Elements/AsTitle.vue"
import AsInputError from "../Forms/AsInputError.vue"

import Button from "primevue/button"
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext"

export default {
    name: "AuditDataForm",
    components: {
        AsTitle,
        AsInputError,
        Button,
        Dropdown,
        InputText,
    },
    props: {
        auditDatas: Array,
        auditData: Object,
        isSending: Boolean,
        entreprises: [],
    },
    setup(props) {
        const state = reactive({
            selectedEntreprise: props.auditData?.idEntreprise || null,
            year: props.auditData?.year || new Date().getFullYear(),
            selectedValue: props.auditData?.value || 1
        });
        const rules = computed(() => ({
            selectedEntreprise: { required },
            year: { required },
            selectedValue: { required },
        }))
        const v$ = useVuelidate(rules, state)
        return { v$, state }
    },
    computed: {
        entreprisesOptions() {
            return this.entreprises.map((el) => {
                return {
                    label: `${el.nom}`,
                    value: el.id,
                };
            });
        },
        valueOptions() {
            return [1, 2, 3, 4].map(e => {
                return {
                    label: this.$t(`ficheBu.audit_data_list.value_enum.${e}`),
                    value: e
                }
            })
        }
    },
    data() {
        return {
            submitted: false,
            auditDataAlreadyExisting: false,
        }
    },
    emits: ["onClose", "onSubmit"],
    methods: {
        handleSubmit(isFormValid) {
            this.v$.$touch()
            if (!isFormValid) {
                return;
            }
            this.submitted = true
            const auditData = {
                id: this.auditData.id,
                idEntreprise: this.state.selectedEntreprise,
                year: this.state.year,
                value: this.state.selectedValue
            }
            this.submitted = false
            this.$emit("onSubmit", auditData)
        },
        onClose() {
            this.submitted = false
            this.$emit("onClose");
        },
        async checkExistingAuditData() {
            const selectedEntreprise = +this.state.selectedEntreprise
            const selectedYear = +this.state.year
            if (selectedEntreprise && selectedYear) {
                const existing = this.auditDatas.find(e => e.idEntreprise === selectedEntreprise && e.year === selectedYear)
                this.auditDataAlreadyExisting = existing && existing.id !== this.auditData?.id
            }
        },
    },
};
</script>